/**
 * `format=columnar` answers (docs/API.md "Series size") carry one shared `timeline` and plain value arrays per
 * series. The panel's chart code reads point series, so a columnar answer is expanded here, once, at the API edge.
 */
import type { MetricPoint, MetricSeries, MetricsResponse } from './api_types';

function expandedPoints(series: MetricSeries, timeline: readonly string[]): MetricPoint[] {
  return timeline.map((pointTime, pointIndex) => ({
    t: pointTime,
    value: series.values?.[pointIndex] ?? null,
    compare_value: series.compare_values?.[pointIndex] ?? null,
    coverage: series.coverage?.[pointIndex] ?? null,
  }));
}

/** The same answer in the points format; a points answer is returned unchanged. */
export function withPointSeries(metricsResponse: MetricsResponse): MetricsResponse {
  if (metricsResponse.series_format !== 'columnar') {
    return metricsResponse;
  }
  const timeline = metricsResponse.timeline ?? [];
  return {
    ...metricsResponse,
    series_format: 'points',
    timeline: null,
    series: metricsResponse.series.map((series) => ({
      store_id: series.store_id,
      metric: series.metric,
      points: expandedPoints(series, timeline),
    })),
  };
}
